var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetastable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    alt: "Logo for MetaStable",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MetaStable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 31.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0954 35.223C25.0954 33.315 24.9673 31.47 24.7701 29.562H34.095L34.4203 33.432C35.4651 32.127 38.0083 28.905 44.5929 28.905C52.1631 28.905 54.312 33.135 54.9626 34.566C57.7029 29.742 62.1386 28.968 65.5294 28.968C72.183 28.968 74.8641 32.604 75.5739 33.792C77.3383 36.411 77.2003 40.047 77.2003 42.666V59.145H67.4811V41.955C67.4811 38.733 66.9587 35.16 61.9316 35.16C56.1553 35.16 56.0271 40.11 56.0271 44.574V59.145H46.308V41.775C46.308 39.453 46.239 35.16 40.8964 35.16C34.8244 35.16 34.8244 39.93 34.8244 41.955V59.145H25.0954V35.223Z",
    fill: "#020202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7701 65.76H77.2299V73.095H24.7701V65.76Z",
    fill: "#020202"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 31.5,
    stroke: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetastable);
export default __webpack_public_path__ + "static/media/metastable.8ce8f6886a3650cd61af36af8fe4791c.svg";
export { ForwardRef as ReactComponent };